import { IResource, Resource, SelectorResult } from 'features/pi/model/resources/Resource';
import { IResourceSelectorFactory } from 'features/pi/model/resources/IResourceSelectorFactory';

export class ImageResource
    extends Resource<'image_url', string>
    implements IResource<'image_url', string>
{
    selectFromFactory<T extends IResourceSelectorFactory<any>>(
        selectorFactory: T,
    ): SelectorResult<T> {
        return selectorFactory.getImg();
    }

    getEntityName(): string {
        return 'ImageResource';
    }
}
